import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { Divider, Grid } from '@material-ui/core';
import GradeIcon from '@material-ui/icons/Grade';
import GradeOutlinedIcon from '@material-ui/icons/GradeOutlined';
import { Field, reduxForm } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import '../Codes/style/tableresponsive.css'
import { isMobile } from 'react-device-detect';
import StandardList from '../Complements/StandardList';

const useStyles = makeStyles({
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  });

const validate = values => {
    const error  = {}
    if (!values.data) {
        error.data = `El campo obligatorio`
    }
    return error
}

const RenderDescriptionForm = props => {
    const { label, handleSubmit, valid, positive, onCancelAction } = props
    return (
        
        <form onSubmit={ handleSubmit } >
        <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
                <Field
                    name="data"
                    id="data"
                    component={ RenderTextFieldRedux }
                    label={label}
                    fullWidth
                    autoFocus = { true }
                    multiline
                    rows={3}
                />
            </Grid>
            <br></br>
            <Grid item xs={6} md={6}>
                <Button 
                    fullWidth
                    variant="contained"
                    color="primary"
                    type="submit" 
                    disabled={!valid}
                >
                    {positive}
                </Button>
            </Grid>
            <Grid item xs={6} md={6}>
                <Button variant="contained" onClick = { () => onCancelAction() }>Cancelar</Button>
            </Grid>
        </Grid>
        </form>
    );
}

const RenderDescriptionFormRedux = reduxForm(
    {
      form: 'RenderDescriptionForm',
      validate
    }
)(RenderDescriptionForm)


const MeterInfoPanel = props => {
    const { openFavorites, favorites, submitMeterProcess, onCancelAction } = props
    const { NumeroMedidor, Cliente, MensajeError, MontoComision, MontoTotal, MontoPagar } = props.data
    /* const { NumeroMedidor, NumeroPartida, Cliente, CodigoCompania,
            CodigoNegocio, MontoVencido, MontoPagar, SecuencialCuenta,
            TipoError, MensajeError, MontoComision, MontoTotal, SecuencialCausalRecaudacion, SecuencialCausalComision } = props.data */
    const classes = useStyles()
    // const bull = <span className={classes.bullet}>•</span>
    return (
        <Card className={classes.root} variant="outlined"> 
            <CardContent>
                {
                    favorites ?
                    <Button
                        size="small"
                        variant="outlined"
                        startIcon={<GradeOutlinedIcon />}
                        onClick = { openFavorites }
                    >Agregar a favoritos</Button> :
                    <Button
                        size="small"
                        variant="outlined"
                        startIcon={<GradeIcon />}
                        disabled
                    >Favorito</Button>
                }
                <br/><br/>
                <Divider></Divider>
                <br/>
                {
                    isMobile ?
                    <Table className = {"table"} >
                        <Thead>
                            <Tr>
                                <Th>Número de medidor:</Th>
                                <Th>Cliente:</Th>
                                <Th>Monto a pagar:</Th>
                                <Th>Monto comisión:</Th>
                                <Th>Monto total:</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            <Tr>
                                <Td>{NumeroMedidor}</Td>
                                <Td>{Cliente ? `${Cliente}` : `${MensajeError}`}</Td>
                                <Td>{MontoPagar}</Td>
                                <Td>{MontoComision}</Td>
                                <Td>{MontoTotal}</Td>
                            </Tr>
                        </Tbody>
                    </Table> :
                    <StandardList
                        dataList ={ [
                            {id:'1', title: `Numero de medidor`, data: `${NumeroMedidor}`, icon: 'format_list_numbered' },
                            {id:'2', title: `Cliente`, data: Cliente ?`${Cliente}` : `${MensajeError}`, icon: 'person'  },
                            {id:'3', title: `Monto a pagar`, data: `${MontoPagar}`, icon: 'local_atm'  },
                            {id:'4', title: `Monto comision`, data: `${MontoComision}`, icon: 'local_atm'  },
                            {id:'5', title: `Monto total`, data: `${MontoTotal}`, icon: 'local_atm'  },
                        ]}
                        primary = {'title'}
                        secondary = {'data'}
                        selectItem = {(val) => {/*console.log(val)*/}}
                        icon = {'school'}
                    />
                }
                
                {/**/}
                <Divider></Divider>
                <br/>    
                {
                    <RenderDescriptionFormRedux  label = "Descripcion" onSubmit = {submitMeterProcess} positive ={'Pagar'} onCancelAction = {onCancelAction}/>
                }
            </CardContent>
            <CardActions>
            </CardActions>
        </Card>
    );
};

MeterInfoPanel.propTypes = {
    data: PropTypes.object.isRequired,
    favorites: PropTypes.bool.isRequired,
};

export default MeterInfoPanel;